<template>
  <div class="LKMunMehFormFooter">
    <v-layout>
      <v-layout class="LKMunMehFormFooter__layout">
        <v-btn
          color="primary"
          rounded
          outlined
          :disabled="loading"
          @click="$emit('prev')"
          v-text="'Перейти назад'"
        />
        <v-btn
          color="primary"
          rounded
          outlined
          :disabled="loading"
          class="ml-btn"
          @click="$emit('main')"
          v-text="'Главный раздел'"
        />
        <v-spacer />
        <v-btn
          color="primary"
          rounded
          :disabled="loading"
          class="ml-btn"
          @click="$emit('next')"
          v-text="'Перейти далее'"
        />
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'LKMunMehHostViewFooter',
  props: {
    loading: Boolean,
  },
}
</script>

<style scoped lang="scss">
.LKMunMehFormFooter {
  @import "~@/assets/scss/components/_LKHeaderButtons.scss";

  margin-top: 16px;

  .ml-btn {
    margin-left: 12px;
  }
}
</style>

